const Dashboard = () => import("./dashboard/views/Dashboard.vue");
import appraisalRoutes from "./appraisal/routes";
import feedbackRoutes from "./feedback/routes";
import TrainingRoutes from "./training/routes";
import TaskManagementRoutes from "./taskManagement/routes";

export default [
  {
    path: "dashboard",
    component: Dashboard,
  },
  {
    path: "appraisal",
    redirect: "/ess/performance/appraisal/self-appraisal",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: appraisalRoutes,
  },
  {
    path: "feedback",
    redirect: "/ess/performance/feedback/view-all",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: feedbackRoutes,
  },
  {
    path: "task-management",
    redirect: "/ess/performance/task-management/task-board",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: TaskManagementRoutes,
  },
  {
    path: "training",
    redirect: "/ess/performance/training/general-training",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: TrainingRoutes,
  },
];
